module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bs-example"
  }, [_c('h1', [_vm._v("Obnova hesla")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showSpinner) ? _c('div', [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showForm1) ? _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.nothing()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_c('nobr', [_vm._v("Nové heslo")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputNewPassword),
      expression: "inputNewPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    ref: "newPassword",
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('newPassword')
    },
    attrs: {
      "type": "password",
      "name": "newPassword",
      "disabled": _vm.submitPending,
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.inputNewPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputNewPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('newPassword')) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v("Vložte prosím nové heslo; minimální délka 6 znaků.")]) : _c('span', [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.submitPending || _vm.errors.has('newPassword') || _vm.inputNewPassword == ''
    },
    on: {
      "click": _vm.submitPassword1
    }
  }, [(_vm.submitPending != 1) ? _c('span', [_vm._v("Pokračovat")]) : _vm._e(), _vm._v(" "), (_vm.submitPending == 1) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.showForm2) ? _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.nothing()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_c('nobr', [_vm._v("Zadejte nové heslo znovu pro kontrolu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputNewPassword2),
      expression: "inputNewPassword2"
    }],
    ref: "newPassword2",
    staticClass: "form-control",
    class: {
      'is-danger': _vm.inputNewPassword2 != '' && !_vm.passwordsMatch()
    },
    attrs: {
      "type": "password",
      "name": "newPassword2",
      "disabled": _vm.submitPending,
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.inputNewPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputNewPassword2 = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.inputNewPassword2 != '' && !_vm.passwordsMatch()) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v("Zadané heslo nesouhlasí. "), _c('a', {
    on: {
      "click": _vm.startOver
    }
  }, [_vm._v("Zadat znovu?")])]) : _c('span', [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.submitPending || !_vm.passwordsMatch() || _vm.inputNewPassword2 == ''
    },
    on: {
      "click": _vm.submitPassword2
    }
  }, [(_vm.submitPending != 1) ? _c('span', [_vm._v("Nastavit nové heslo")]) : _vm._e(), _vm._v(" "), (_vm.submitPending == 1) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.showResult) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._v("\n    Nové heslo je nastaveno. Můžete "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("pokračovat na přihlášení")]), _vm._v(".\n  ")], 1) : _vm._e(), _vm._v(" "), (_vm.displayError) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.displayError) + "\n    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    attrs: {
      "href": "/reset-password"
    }
  }, [_vm._v("Zapomněli jste heslo?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4879154c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPasswordConfirm.vue
// module id = 303
// module chunks = 1 2